// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/sports.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/sports.proto.
 */
export const file_proto_model_core_place_types_sports = /*@__PURE__*/
  fileDesc("Cilwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL3Nwb3J0cy5wcm90bxIGY2FybWVuKvYECg9TcG9ydHNQbGFjZVR5cGUSIQodU1BPUlRTX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIbChdTUE9SVFNfUExBQ0VfVFlQRV9BUkVOQRABEiQKIFNQT1JUU19QTEFDRV9UWVBFX0FUSExFVElDX0ZJRUxEEAISJQohU1BPUlRTX1BMQUNFX1RZUEVfRklTSElOR19DSEFSVEVSEAMSIgoeU1BPUlRTX1BMQUNFX1RZUEVfRklTSElOR19QT05EEAQSJAogU1BPUlRTX1BMQUNFX1RZUEVfRklUTkVTU19DRU5URVIQBRIhCh1TUE9SVFNfUExBQ0VfVFlQRV9HT0xGX0NPVVJTRRAGEhkKFVNQT1JUU19QTEFDRV9UWVBFX0dZTRAHEiYKIlNQT1JUU19QTEFDRV9UWVBFX0lDRV9TS0FUSU5HX1JJTksQCBIgChxTUE9SVFNfUExBQ0VfVFlQRV9QTEFZR1JPVU5EEAkSIAocU1BPUlRTX1BMQUNFX1RZUEVfU0tJX1JFU09SVBAKEi4KKlNQT1JUU19QTEFDRV9UWVBFX1NQT1JUU19BQ1RJVklUWV9MT0NBVElPThALEiEKHVNQT1JUU19QTEFDRV9UWVBFX1NQT1JUU19DTFVCEAwSJQohU1BPUlRTX1BMQUNFX1RZUEVfU1BPUlRTX0NPQUNISU5HEA0SJAogU1BPUlRTX1BMQUNFX1RZUEVfU1BPUlRTX0NPTVBMRVgQDhIdChlTUE9SVFNfUExBQ0VfVFlQRV9TVEFESVVNEA8SIwofU1BPUlRTX1BMQUNFX1RZUEVfU1dJTU1JTkdfUE9PTBAQQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM");

/**
 * Describes the enum carmen.SportsPlaceType.
 */
export const SportsPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_sports, 0);

/**
 * Sports-related place types
 *
 * @generated from enum carmen.SportsPlaceType
 */
export const SportsPlaceType = /*@__PURE__*/
  tsEnum(SportsPlaceTypeSchema);

